"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSimpleDevices = exports.mapWarrantyRole = void 0;
const mapWarrantyRole = (warrantyRole) => ({
    name: warrantyRole.name,
    auth0sub: warrantyRole.sub,
    userRole: warrantyRole.userRole,
    createdAt: new Date(warrantyRole.createdAt),
});
exports.mapWarrantyRole = mapWarrantyRole;
const mapSimpleDevices = (simples) => {
    const parsedSimple = [];
    for (const simple of Object.values(simples)) {
        const parse = {
            deviceID: simple.id,
            model: {
                model: simple.model.model,
                serialNumber: simple.model.serialNumber,
                lotNumber: simple.model.lotNumber,
            },
            provisioner: (0, exports.mapWarrantyRole)(simple.provisioner),
            inaugurator: simple.inaugurator === null ? null : (0, exports.mapWarrantyRole)(simple.inaugurator),
            warrantyExpiration: new Date(simple.warrantyExpiration),
        };
        parsedSimple.push(parse);
    }
    return parsedSimple;
};
exports.mapSimpleDevices = mapSimpleDevices;
//# sourceMappingURL=Simples.js.map